import { map, isEmpty, filter } from 'lodash';
import React, { useState } from 'react';
import Button from '../../components/Button';
import IconButton from '../../components/IconButton';
import { useNavigate } from 'react-router-dom';
import AddConversation from './components/AddConversation';
import { Dialog, Avatar } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import NewUserInfo from '../../Main/NewUserInfo';
import EmergencyButton from '../Components/EmergencyButton';
import useStore from '../../Store/Store';
import styles from '../../Main/main.styles';
import AddIcon from '@mui/icons-material/Add';
import './chats.css';
import BoyPic from '../../images/boy.png';
import {
  getConversations,
  markMessageAsRead,
  sendMessage,
  subscribeToMessages,
} from '../../utils/firestoreMessageConfigs';
import { chatDateFormat } from '../../utils';
import RecipientsSelector from '../../CanCare/Components/RecipientsSelector';
import { chatWithCompanion, getCaregivers, getRecipientCaregivers } from '../../utils/api';
import { useMutation, useQuery } from 'react-query';
import { ICON_BUTTON_TYPE } from '../../constants';
import { useMediaQuery } from '@mui/material';
import CompanionPic from '../../images/companion_icon.svg';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import SideBar from '../../components/SideBar';
import { useTranslation } from 'react-i18next';
const useStyles = makeStyles()(styles);

const Chats = () => {
  const user = useStore((state) => state.user);
  const careRecipients = useStore((state) => state.careRecipients);
  const selectedRecipient = useStore((state) => state.selectedRecipient);
  const { t } = useTranslation();
  const { classes } = useStyles();
  const history = useNavigate();
  const scrollRef = React.useRef();
  const [addConversationModal, setAddConversationModal] = useState(false);
  const [conversations, setConversations] = useState([]);
  const [activeConversations, setActiveConversations] = useState(null);
  const [message, setMessage] = useState('');
  const [chatLoader, setChatLoader] = useState(false);
  const [messages, setMessages] = useState([]);
  const [userCaregivers, setUserCaregivers] = useState(null);
  const isMobile = useMediaQuery('(max-width:768px)');
  const [showConversationList, setShowConversationList] = useState(true);
  const width = useStore((state) => state.screenWidth);

  const {
    data: caregivers,
    isLoading,
    refetch,
  } = useQuery(
    ['getCaregivers', 'getRecipientCaregivers', selectedRecipient],
    () =>
      isEmpty(selectedRecipient)
        ? getCaregivers({ userId: user?._id || user?.id })
        : getRecipientCaregivers({ userId: user?._id || user?.id, recipientId: selectedRecipient }),
    {
      retry: false,
      cacheTime: 0,
    },
  );

  const chatWithCompanionMutation = useMutation(chatWithCompanion, {
    onSuccess: async (data) => {
      setChatLoader(true);
      await sendMessage(activeConversations?.id, 'bot', data?.data);
      setMessage('');
      setChatLoader(false);
      scrollToBottom();
    },
    onError: (error) => {
      console.log('error =====> ', error);
      setChatLoader(false);
      setMessage('');
    },
  });
  React.useEffect(() => {
    if (!isEmpty(caregivers)) {
      let caregiver = {};

      for (let user of caregivers?.data) {
        caregiver = {
          ...caregiver,
          [user.caregiverId?._id]: {
            ...user.caregiverId,
          },
        };
      }

      setUserCaregivers(caregiver);
    }
  }, [caregivers]);

  const scrollToBottom = () => {
    setTimeout(() => {
      scrollRef.current?.scrollIntoView({ behavior: 'smooth' });
    }, 100);
  };

  const handlePressEnter = async (e) => {
    if (e.key === 'Enter') {
      getNewMessage();
    }
  };

  const getNewMessage = async () => {
    if (isEmpty(message)) return;
    setChatLoader(true);
    scrollToBottom();
    try {
      await sendMessage(activeConversations?.id, user?._id, message);

      if (
        message.startsWith('/') ||
        message.toLowerCase().startsWith('@companion') ||
        message.toLowerCase().startsWith('@can') ||
        activeConversations?.isCanCompanionChat
      ) {
        chatWithCompanionMutation.mutate({ userId: user?._id, message });
      }

      setMessage('');
      setChatLoader(false);
      scrollToBottom();
    } catch (error) {
      console.log('error=====>', error);
      setMessage('');
      setChatLoader(false);
      scrollToBottom();
    } finally {
      setChatLoader(false);
    }
  };

  React.useEffect(() => {
    const unsubscribe = getConversations(user?._id, selectedRecipient, (updatedConversations) => {
      setConversations(updatedConversations);
    });

    return () => (unsubscribe ? unsubscribe() : null);
  }, [user, selectedRecipient]);

  const closeConversationModal = () => setAddConversationModal(false);

  React.useEffect(() => {
    const unsubscribe = subscribeToMessages(activeConversations?.id, (snapshot) => {
      const messages = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setMessages(messages || []);
      scrollToBottom();

      messages.forEach((message) => {
        if (!message.readBy?.includes(user?._id)) {
          markMessageAsRead(activeConversations?.id, message.id, user?._id);
        }
      });
    });

    return () => (unsubscribe ? unsubscribe() : null);
  }, [activeConversations?.id, selectedRecipient]);

  const handleSetActiveConversations = (item) => {
    if (item?.participants.length === 2) {
      const participantsId = filter(item?.participants || [], (item) => item !== user?._id)[0];
      setActiveConversations({ ...item, participantsId });
    } else {
      setActiveConversations(item);
    }
  };

  const handleConversationClick = (item) => {
    handleSetActiveConversations(item);
    if (isMobile) {
      setShowConversationList(false);
    }
  };

  const handleBackToList = () => {
    setShowConversationList(true);
    setActiveConversations(null);
  };

  return (
    <>
      <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
        <div>
          <SideBar />
        </div>

        <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
          <NewUserInfo isSideBar={false} />
          <RecipientsSelector />
          <div
            className="flex-column-a"
            style={{
              background: '#fff',
              borderRadius: '20px',
              height: '70vh',
              left: width > 850 ? '15%' : '0%',
            }}
          >
            <div style={{ display: 'flex', height: '100%' }} className="chat-container">
              <div
                className="conversation-main-div"
                style={{
                  display: isMobile && !showConversationList ? 'none' : 'block',
                  width: isMobile ? '100%' : '25%',
                }}
              >
                <div className="can-care-conversation">
                  {isEmpty(conversations) && <p style={{ textAlign: 'center' }}>No Conversations</p>}
                  {!isEmpty(conversations) &&
                    conversations.map((item) => {
                      const userId = filter(item?.participants || [], (item) => item !== user?._id)[0];
                      const userName =
                        careRecipients[userId]?.userInfo?.firstName ||
                        (userCaregivers && userCaregivers[userId]?.userInfo?.firstName);
                      const DP = !isEmpty(item?.name)
                        ? BoyPic
                        : careRecipients[userId]?.imageUrl ||
                          (userCaregivers && userCaregivers[userId]?.userInfo?.imageUrl) ||
                          BoyPic;
                      return (
                        <div
                          className="can-care-conversation-internal-box"
                          style={{
                            background: activeConversations?.id === item?.id ? '#f5f5f7' : '#fff',
                            height: '70px',
                            overflow: 'hidden',
                          }}
                          onClick={() => handleConversationClick(item)}
                        >
                          <div style={{ display: 'flex' }}>
                            <Avatar src={DP} alt="dp" className="display-pic" />
                            <div style={{ marginLeft: '5px' }}>
                              <span className="can-care-conversation-internal-box-title">
                                {!isEmpty(item?.name) ? item?.name : userName}
                              </span>
                              <p style={{ fontSize: '12px', height: '40px', overflow: 'hidden' }}>
                                {/* {item?.lastMessage?.text || ''} */}
                              </p>
                            </div>
                          </div>
                          <div>
                            {item?.unreadCounts && item?.unreadCounts[user?._id] > 0 ? (
                              <p
                                style={{
                                  padding: '7px',
                                  borderRadius: '50%',
                                  width: '10px',
                                  height: '10px',
                                  fontSize: '10px',
                                  background: '#277668',
                                  color: '#fff',
                                  textAlign: 'center',
                                }}
                              >
                                {item?.unreadCounts[user?._id] || 0}
                              </p>
                            ) : (
                              <p style={{ fontSize: '8px' }}>
                                {chatDateFormat(item?.lastMessage?.createdAt || item?.updatedAt)}
                              </p>
                            )}
                          </div>
                        </div>
                      );
                    })}
                </div>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                  }}
                >
                  <Button
                    bg="light"
                    onClick={() => setAddConversationModal(true)}
                    text={t('startNewChat')}
                    startIcon={<AddIcon />}
                  />
                </div>
              </div>
              {(!isEmpty(activeConversations?.id) || !isEmpty(messages)) && (
                <div
                  className="chatboxdiv"
                  style={{
                    display: isMobile && showConversationList ? 'none' : 'grid',
                    width: isMobile ? '100%' : 'auto',
                  }}
                >
                  <div className="user-dp">
                    {isMobile && (
                      <IconButton
                        onClick={handleBackToList}
                        style={{ marginRight: '10px' }}
                        type={ICON_BUTTON_TYPE.back}
                      />
                    )}
                    <Avatar
                      src={
                        !isEmpty(activeConversations?.name)
                          ? BoyPic
                          : careRecipients[activeConversations?.participantsId]?.imageUrl ||
                            userCaregivers[activeConversations?.participantsId]?.userInfo?.imageUrl ||
                            BoyPic
                      }
                      alt="dp"
                      className="display-pic"
                    />
                    <div style={{ marginLeft: '20px' }}>
                      <b>
                        {!isEmpty(activeConversations?.name)
                          ? activeConversations?.name
                          : careRecipients[activeConversations?.participantsId]?.userInfo?.firstName ||
                            userCaregivers[activeConversations?.participantsId]?.userInfo?.firstName}
                      </b>
                      <br />
                      <small>{chatDateFormat(activeConversations?.updatedAt)}</small>
                    </div>
                  </div>
                  <div className="chatbox">
                    <div className="chatbox-inner">
                      <div className="chat-messages">
                        {map(messages, ({ text, senderId, createdAt }, idx) => {
                          const DP =
                            careRecipients[senderId]?.imageUrl ||
                            userCaregivers[senderId]?.userInfo?.imageUrl ||
                            BoyPic;
                          const userName =
                            careRecipients[senderId]?.userInfo?.firstName ||
                            userCaregivers[senderId]?.userInfo?.firstName;
                          return (
                            <div key={idx}>
                              {senderId === user?._id ? (
                                <div className={'message-body-sender'}>
                                  <div className={'sender-message'}>
                                    <span className="username">
                                      {user?.userInfo?.firstName || ''} {'(you)'}
                                      <span className="message-time">{chatDateFormat(createdAt)}</span>
                                    </span>
                                    <div className="message">
                                      <ReactMarkdown remarkPlugins={[remarkGfm]}>{text}</ReactMarkdown>
                                    </div>
                                  </div>
                                  <Avatar src={user?.userInfo?.imageUrl || BoyPic} alt="dp" className="display-pic" />
                                </div>
                              ) : senderId === 'bot' ? (
                                <div className={'message-body-companion'}>
                                  <Avatar src={CompanionPic} alt="dp" className="display-pic" />
                                  <div className={'companion-message'}>
                                    <span className="username">
                                      {userName}
                                      <span className="message-time">{chatDateFormat(createdAt)}</span>
                                    </span>
                                    <div className="message">
                                      <ReactMarkdown remarkPlugins={[remarkGfm]}>{text}</ReactMarkdown>
                                    </div>
                                  </div>
                                </div>
                              ) : (
                                <div className={'message-body-bot'}>
                                  <Avatar src={DP} alt="dp" className="display-pic" />
                                  <div className={'bot-message'}>
                                    <span className="username">
                                      {userName}
                                      <span className="message-time">{chatDateFormat(createdAt)}</span>
                                    </span>
                                    <div className="message">
                                      <ReactMarkdown remarkPlugins={[remarkGfm]}>{text}</ReactMarkdown>
                                    </div>
                                  </div>
                                </div>
                              )}
                            </div>
                          );
                        })}
                        <div ref={scrollRef} />
                        <div className="chat-bottom-spacer" />
                      </div>
                    </div>

                    <div className="input-div">
                      <input
                        type="text"
                        className="chat-input"
                        placeholder={
                          chatLoader
                            ? 'Generating response...'
                            : "Type a message or use '/', @companion or @CAN for ask CAN Companion"
                        }
                        onChange={(e) => {
                          setMessage(e.target.value);
                        }}
                        onKeyPress={handlePressEnter}
                        value={message}
                      />
                      <IconButton type={ICON_BUTTON_TYPE.send} onClick={getNewMessage} disabled={chatLoader} />
                    </div>
                  </div>
                </div>
              )}

              <Dialog open={addConversationModal} maxWidth={false}>
                <AddConversation closeModal={closeConversationModal} user={user} caregivers={caregivers} />
              </Dialog>
            </div>
          </div>
          <EmergencyButton />
        </div>
      </div>
    </>
  );
};

export default Chats;
